// Mock data for EZVI landing page

export const features = [
  {
    id: 1,
    icon: "Search",
    title: "Confronta Tutti gli Operatori",
    description: "Trova le migliori tariffe tra tutti i provider di ricarica in Italia, senza essere vincolato a nessun operatore."
  },
  {
    id: 2,
    icon: "MapPin",
    title: "Navigazione Integrata",
    description: "Pianifica il tuo percorso e scopri le colonnine più convenienti lungo la strada. Mai più sorprese sui costi."
  },
  {
    id: 3,
    icon: "Zap",
    title: "Ricarica Intelligente",
    description: "Filtra per potenza, tipo di connettore e disponibilità in tempo reale. La colonnina perfetta è sempre a portata di tap."
  },
  {
    id: 4,
    icon: "PiggyBank",
    title: "Risparmia Ogni Volta",
    description: "I nostri utenti risparmiano in media il 30% sui costi di ricarica scegliendo l'operatore più conveniente."
  },
  {
    id: 5,
    icon: "Clock",
    title: "Aggiornamenti in Tempo Reale",
    description: "Prezzi, disponibilità e stato delle colonnine sempre aggiornati. Informazioni affidabili, sempre."
  },
  {
    id: 6,
    icon: "Shield",
    title: "100% Indipendente",
    description: "Non vendiamo energia né gestiamo colonnine. Il nostro unico interesse è aiutarti a trovare il miglior prezzo."
  }
];

export const howItWorks = [
  {
    id: 1,
    step: "01",
    title: "Cerca la Colonnina",
    description: "Inserisci la tua posizione o destinazione e visualizza tutte le colonnine disponibili sulla mappa."
  },
  {
    id: 2,
    step: "02",
    title: "Confronta i Prezzi",
    description: "Ogni colonnina mostra i prezzi di tutti gli operatori. Scegli quello più conveniente per te."
  },
  {
    id: 3,
    step: "03",
    title: "Ricarica e Risparmia",
    description: "Usa l'app dell'operatore scelto per la ricarica. Nessun costo aggiuntivo, solo risparmio."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Daniele",
    role: "Ford \"Gatto\" Puma",
    avatar: "dani2.png",
    text: "Quest'estate per un viaggio da Milano a Cosenza ho usato esclusivamente Tesla per evitare il caos delle colonnine. La prossima volta c'e' EZ-VI'!",
    rating: 5
  },
  {
    id: 2,
    name: "Alessandro",
    role: "Dacia \"La centenaria\" Spring",
    avatar: "ale.png",
    text: "Con la mia Dacia faccio 100.000km ogni 6 mesi. Con EZ-VI' ricarico ogni volta che parcheggio, e chi ha bisogno di 100kwh??",
    rating: 5
  },
  {
    id: 3,
    name: "Mauro",
    role: "Volkswagen id.4",
    avatar: "mauro.png",
    text: "Ho da poco preso la mia prima EV. Grazie a EZ-VI' risparmio almeno 20 euro al mese e la mia lavatrice e' carica e felice.",
    rating: 5
  }
];

  /*{
    id: 3,
    name: "Raffaele",
    role: "Fleet Manager",
    avatar: "lele.png",
    text: "Gestiamo 50 veicoli elettrici aziendali. EZVI ci ha permesso di ottimizzare i costi di ricarica del 25%. Essenziale per noi.",
    rating: 5
  }*/

export const stats = [
  { id: 1, value: "50.000+", label: "Colonnine Mappate" },
  { id: 2, value: "30%", label: "Risparmio Medio" },
  { id: 3, value: "15+", label: "Operatori Confrontati" },
  { id: 4, value: "4.8★", label: "Valutazione App Store" }
];

export const faqItems = [
  {
    id: "item-1",
    question: "EZVI è gratuita?",
    answer: "Sì, EZVI è completamente gratuita per tutti gli utenti. Guadagniamo attraverso partnership con gli operatori, senza mai influenzare i risultati di ricerca."
  },
  {
    id: "item-2",
    question: "Come fa EZVI a conoscere i prezzi di tutti gli operatori?",
    answer: "Collaboriamo direttamente con gli operatori e utilizziamo dati pubblici per garantire prezzi sempre aggiornati. Il nostro sistema verifica le tariffe più volte al giorno."
  },
  {
    id: "item-3",
    question: "Devo registrarmi a tutti gli operatori?",
    answer: "EZVI ti mostra solo il prezzo migliore. Per la ricarica effettiva, dovrai usare l'app dell'operatore scelto. Ti aiutiamo anche a capire quale abbonamento conviene di più."
  },
  {
    id: "item-4",
    question: "Funziona con tutte le auto elettriche?",
    answer: "Assolutamente sì! EZVI funziona con qualsiasi veicolo elettrico. Puoi impostare il tipo di connettore della tua auto per filtrare solo le colonnine compatibili."
  },
  {
    id: "item-5",
    question: "I dati sono affidabili?",
    answer: "Sì, i nostri dati provengono direttamente dagli operatori e vengono verificati dalla nostra community. Se trovi un'informazione errata, puoi segnalarla e la correggiamo subito."
  }
];

export const navItems = [
  { id: 1, label: "Funzionalità", href: "#features" },
  { id: 2, label: "Come Funziona", href: "#how-it-works" },
  { id: 3, label: "Recensioni", href: "#testimonials" },
  { id: 4, label: "FAQ", href: "#faq" }
];
